<div class="content-container">
  <div class="widget-container">
    <ng-content select="[widget-area]"></ng-content>
  </div>
  <div class="form-container">
    <ng-content select="[form-area]"></ng-content>
  </div>
  <div class="linked-actions-container">
    <ng-content select="[linked-actions-area]"></ng-content>
  </div>
</div>
